import styled from '@emotion/styled';

export const CardWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
